module.exports = __webpack_public_path__ + "static/media/bdsports_catalog_header.1a5aa24c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/BlackDiamond/bdsports_catalog_header.jpg
// module id = 641
// module chunks = 0